import { Button, Stack } from '@chakra-ui/react';

interface PaginationProps {
  currentPage: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPageChange: (page: number) => void;
}

export function Pagination({
  currentPage,
  canPreviousPage,
  canNextPage,
  onPageChange,
}: PaginationProps) {
  return (
    <Stack
      spacing="4"
      direction={['column', 'column', 'row']}
      mt={['4', '4', '0']}
    >
      <Button
        onClick={() => {
          if (canPreviousPage) onPageChange(currentPage - 1);
        }}
        isDisabled={!canPreviousPage}
        colorScheme="white"
        borderRadius="14px"
        color="brand-dark.300"
        fontSize="xs"
        textTransform="uppercase"
        boxShadow="1px 1px 8px -3px rgba(5, 6, 27, 0.25)"
      >
        Voltar
      </Button>

      <Button
        onClick={() => {
          if (canNextPage) onPageChange(currentPage + 1);
        }}
        isDisabled={!canNextPage}
        colorScheme="white"
        borderRadius="14px"
        color="brand-dark.300"
        fontSize="xs"
        textTransform="uppercase"
        boxShadow="1px 1px 8px -3px rgba(5, 6, 27, 0.25)"
      >
        Próxima
      </Button>
    </Stack>
  );
}
